<template>
    <div class="fls">
        <div class="l5gidkmd">
            <el-button
                v-if="$projectName === 'database' && !iswework"
                icon="el-icon-star-off"
                type="primary"
                size="mini"
                class="l5hzbn39"
                @click="handleCollect"
            >
                收藏
            </el-button>
            <el-button
                v-if="!isMobile && !iswework"
                icon="el-icon-printer"
                type="primary"
                size="mini"
                class="l5hzbn39 l5ggx5up"
                @click="window.print"
            >
                打印
            </el-button>
            <slot name="button"></slot>
        </div>
        <ul class="l5gh2nga">
            <li>
                <WxRouterLink to="/"> 首页 </WxRouterLink>
            </li>
            <template v-if="!['cpbs'].includes(dbName)">
                <li class="l5gh43ix l9i8r3pi_id">&gt;</li>
                <li class="l9i8o38f l9i8r79h_id">
                    <WxRouterLink :to="`/${dbName}`">
                        {{ dbNameCn }}
                    </WxRouterLink>
                </li>
            </template>
            <li class="l5gh43ix lbuqgftc_id">&gt;</li>
            <li>当前位置</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "ViewsDetailComponentsToolsBlock",
    props: {
        dbNameCn: {
            type: String,
            required: true,
        },
    },
    computed: {
        dbName() {
            let res = this.$route.params.dbName;
            if (this.$route.params.dbName  == 'chictrdetail') {
                res = 'chictr';
            }
            return res;
        },
    },
    methods: {
        // 收藏
        handleCollect() {
            this.$store.layer.actions.showLayer({
                comPromise: import("@/components/async/layer/Collect.vue"),
                comOptions: {
                    attrs: {
                        defaultCondition: [
                            {
                                label: "位置",
                                data: [
                                    {
                                        label: this.dbNameCn,
                                    },
                                ],
                            },
                        ],
                    },
                },
                layerOptions: {
                    title: "收藏当前页面",
                    area: ["505px", "439px"],
                    maxmin: false,
                },
            });
        },
    },
};
</script>

<style lang="less">
@import (reference) "@/assets/less/index.less";
.l5ggx5up {
    background: #ff9139 !important;
    border-color: #ff9139 !important;
}
.l5gh2nga {
    .fs12;
    .mt4;
    li {
        .dib;
    }
}
.l5gh43ix {
    .ml4;
    .mr4;
}
.l5gidkmd {
    .tr;
}
.l5hzbn39 {
    .dif;
    .aic;
    // reset elementui
    i {
        .fs14;
    }
}
</style>

<style lang="less">
@import (reference) "@/assets/less/index.less";
// 移动端
@media screen and (max-width: 750px) {
    .l5gidkmd {
        .mt4;
    }
}
</style>
